var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveLogoAlone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 433.8 104",
    style: {
      enableBackground: "new 0 0 433.8 104"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#424BED;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    transform: "translate(-1069 -255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    transform: "translate(836 19)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,297.3h-35.7l-7,16.5H233l32.1-71.4h13.1l32.2,71.4h-13.9L289.4,297.3z M285,286.9l-13.5-31.2 l-13.4,31.2H285z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.7,262.2c4.2,2.3,7.5,5.6,9.8,9.8c2.4,4.2,3.6,9.1,3.6,14.6s-1.2,10.4-3.6,14.6 c-2.4,4.2-5.7,7.5-9.8,9.8c-4.2,2.3-8.9,3.5-14.2,3.5c-7.3,0-13.2-2.4-17.4-7.3v26.4h-12.8v-74.3h12.1v7.1 c2.1-2.6,4.7-4.5,7.8-5.8s6.5-1.9,10.3-1.9C352.8,258.7,357.5,259.9,361.7,262.2z M357.6,298.9c3-3.1,4.5-7.2,4.5-12.3 c0-5.1-1.5-9.2-4.5-12.3c-3-3.1-6.9-4.7-11.6-4.7c-3.1,0-5.8,0.7-8.3,2.1c-2.4,1.4-4.4,3.4-5.8,6c-1.4,2.6-2.1,5.6-2.1,9 c0,3.4,0.7,6.4,2.1,9c1.4,2.6,3.4,4.6,5.8,6c2.4,1.4,5.2,2.1,8.3,2.1C350.7,303.6,354.6,302,357.6,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.6,262.2c4.2,2.3,7.5,5.6,9.8,9.8c2.4,4.2,3.6,9.1,3.6,14.6s-1.2,10.4-3.6,14.6 c-2.4,4.2-5.7,7.5-9.8,9.8c-4.2,2.3-8.9,3.5-14.2,3.5c-7.3,0-13.2-2.4-17.4-7.3v26.4h-12.8v-74.3h12.1v7.1 c2.1-2.6,4.7-4.5,7.8-5.8s6.5-1.9,10.3-1.9C421.7,258.7,426.4,259.9,430.6,262.2z M426.5,298.9c3-3.1,4.5-7.2,4.5-12.3 c0-5.1-1.5-9.2-4.5-12.3c-3-3.1-6.9-4.7-11.6-4.7c-3.1,0-5.8,0.7-8.3,2.1c-2.4,1.4-4.4,3.4-5.8,6c-1.4,2.6-2.1,5.6-2.1,9 c0,3.4,0.7,6.4,2.1,9c1.4,2.6,3.4,4.6,5.8,6c2.4,1.4,5.2,2.1,8.3,2.1C419.7,303.6,423.5,302,426.5,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.7,258.7v12.1c-1.1-0.2-2.1-0.3-3-0.3c-5,0-8.8,1.4-11.6,4.3c-2.8,2.9-4.2,7.1-4.2,12.5v26.4h-12.8 v-54.5h12.1v8C471,261.6,477.4,258.7,486.7,258.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M505.5,310.9c-4.4-2.4-7.9-5.7-10.4-9.9s-3.7-9.1-3.7-14.4c0-5.4,1.2-10.2,3.7-14.4s5.9-7.5,10.4-9.9 c4.4-2.4,9.4-3.6,14.9-3.6c5.6,0,10.6,1.2,15,3.6c4.4,2.4,7.9,5.7,10.4,9.9c2.5,4.2,3.7,9,3.7,14.4c0,5.4-1.2,10.2-3.7,14.4 c-2.5,4.2-5.9,7.6-10.4,9.9c-4.4,2.4-9.4,3.6-15,3.6C514.9,314.5,510,313.3,505.5,310.9z M532.1,298.9c3.1-3.1,4.6-7.2,4.6-12.3 c0-5.1-1.5-9.2-4.6-12.3c-3.1-3.1-6.9-4.7-11.6-4.7c-4.7,0-8.6,1.6-11.6,4.7c-3,3.1-4.5,7.2-4.5,12.3s1.5,9.2,4.5,12.3 s6.9,4.7,11.6,4.7C525.1,303.6,529,302,532.1,298.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M610.2,259.3l-23.4,54.5h-13.2l-23.4-54.5h13.3l16.9,40.4l17.4-40.4H610.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M666.6,290.6h-42.7c0.7,4,2.7,7.2,5.9,9.5s7.1,3.5,11.8,3.5c6,0,10.9-2,14.8-5.9l6.8,7.9 c-2.4,2.9-5.5,5.1-9.3,6.6c-3.7,1.5-8,2.2-12.6,2.2c-6,0-11.3-1.2-15.8-3.6c-4.6-2.4-8.1-5.7-10.6-9.9c-2.5-4.2-3.7-9.1-3.7-14.4 s1.2-10.1,3.6-14.3c2.4-4.2,5.8-7.6,10-9.9c4.3-2.4,9.1-3.6,14.5-3.6c5.3,0,10,1.2,14.2,3.5s7.4,5.6,9.8,9.9 c2.3,4.3,3.5,9.2,3.5,14.7C666.8,287.7,666.7,289,666.6,290.6z M628.9,272.5c-2.8,2.4-4.5,5.6-5.2,9.6h30.9 c-0.5-3.9-2.2-7.1-5-9.6c-2.8-2.4-6.3-3.7-10.4-3.7C635.2,268.9,631.7,270.1,628.9,272.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveLogoAlone);
export default __webpack_public_path__ + "static/media/Approve_logo_alone.8d12965a2b18d7a966d1c729fb58e81c.svg";
export { ForwardRef as ReactComponent };